import { generateTypes } from '../../utils/HttpReducerHelper';
import { createType } from '../../utils/helpers';

export const playbookContent = generateTypes('PLAYBOOK', 'CONTENT');
export const filtersById = generateTypes('PLAYBOOK', 'FILTERS');
export const shareUrl = generateTypes('PLAYBOOK', 'SHARE_URL');
export const clearShareUrl = createType('PLAYBOOK', 'CLEAR_SHARE_URL');
